// extracted by mini-css-extract-plugin
export var checkbox = "ShoppingCredit_checkbox__X8Eok";
export var checkboxContainer = "ShoppingCredit_checkboxContainer__DqBjU";
export var checkboxLabel = "ShoppingCredit_checkboxLabel__azPl0";
export var disclaimer = "ShoppingCredit_disclaimer__mq0jg";
export var pinkShoppingCreditContainer = "ShoppingCredit_pinkShoppingCreditContainer__-FgPW";
export var shoppingCreditContainer = "ShoppingCredit_shoppingCreditContainer__JQVzh";